import { useQuery } from "react-query";
import { magento } from "@jti/magento";
export const useStockStatuses = ({ categoriesSKUList, onSuccess, select, }) => {
    const queryState = useQuery(["STOCK_STATUSES", ...categoriesSKUList], () => magento.getStockStatuses(categoriesSKUList, categoriesSKUList.length), {
        enabled: categoriesSKUList.length > 0,
        onSuccess,
        select,
    });
    return queryState;
};
//# sourceMappingURL=useStockStatuses.js.map